import React from 'react'

import { makeBtStyles } from '../Theme'
import { CONTENT_WIDTH } from '../components/defaultStyleVars'
import { MIN_TABLET_SIZE } from '../utils'

const useStyles = makeBtStyles(theme => ({
  contentWrapper: {
    margin: '30px auto',
    width: `${CONTENT_WIDTH}px`,
    maxWidth: '100%',
    alignSelf: 'center',
    [theme.breakpoints.down(MIN_TABLET_SIZE)]: {
      width: '100%',
      margin: '30px 0',
      maxWidth: 'none',
    },
  },
}))

export default function ReturnsPage({ children }: { children: React.ReactNode }) {
  const classes = useStyles()

  return <div className={classes.contentWrapper}>{children}</div>
}
